<template>
	<article class="d-self-service-page-custom">
		<PageHero v-bind="{ ...header, breadcrumb }" class="mb-xl" />
		<div class=">=1024:pl-1col mx-layout-margin relative">
			<!-- Link info -->
			<div
				v-if="link && link.length > 0"
				class="
					w-3col
					<1024:w-full
					>=1024:absolute >=1024:h-full
					left-0
					top-0
					<1024:mb-lg
					mx-auto
				"
			>
				<div
					v-if="link && link.length > 0"
					ref="content"
					:class="[
						'>=1024:sticky >=1024:top-lg transform',
						'duration-200 ease-smooth-out',
						{ 'opacity-5 scale-95 pointer-events-none': hidden },
					]"
				>
					<NuxtLinkExt
						class="block w-fit"
						:to="link[0].url"
						:target="link[0].target"
					>
						<BaseButton tag="div" class="w-fit mb-sm">
							<template #default>
								<div v-html="link[0].name"></div>
							</template>
							<template #icon>
								<div class="flex">
									<SvgExternalArrowIcon
										class="w-14 h-14 mr-12"
									/>
									<SvgMitidIcon
										v-if="requiredMitId"
										class="w-32 h-14"
									/>
								</div>
							</template>
						</BaseButton>
					</NuxtLinkExt>
				</div>

				<!-- NOT USED ANYMORE
				<div class="s-rich-text" v-html="linkDescription"></div>
				-->
			</div>
			<div class="w-full">
				<!-- This is what you need -->
				<div
					v-if="thisIsWhatYouNeed"
					class="
						s-rich-text
						w-full
						>=1024:w-6col
						mx-auto
						d-self-service-page-custom__scooting-content
						mb-lg
					"
				>
					<h3 class="mb-sm">Du får brug for</h3>
					<ul>
						<li
							v-for="(line, index) in thisIsWhatYouNeed"
							:key="index"
							v-html="line"
						></li>
					</ul>
				</div>
				<!-- This is how you do -->
				<div
					v-if="thisIsHowYouDo"
					:class="[
						's-rich-text w-full >=1024:w-6col mx-auto',
						'd-self-service-page-custom__scooting-content',
						{ 'mb-lg': !contentElements.length },
					]"
				>
					<h3 class="mb-sm">Sådan gør du</h3>
					<ol>
						<li
							v-for="(line, index) in thisIsHowYouDo"
							:key="index"
							v-html="line"
						></li>
					</ol>
				</div>

				<BlockList
					:block-list="contentElements"
					class="d-self-service-page-custom__block-list w-full"
				/>
			</div>
		</div>

		<FeedbackForm v-if="activateFeedback" class="mb-lg" />

		<!-- Related pages -->
		<RelatedPages
			v-if="showRelatedPages && showRelatedPages.pages.length"
			:title="showRelatedPages.title"
			:items="showRelatedPages.pages"
		/>
	</article>
</template>

<script>
import BlockList from '~/components/main/BlockList';
import PageHero from '~/components/main/PageHero';
import SvgExternalArrowIcon from '~/assets/svgs/external-arrow-icon.svg?inline';
import SvgMitidIcon from '~/assets/svgs/mitid-icon.svg?inline';
import RelatedPages from '~/components/shared/RelatedPages';
import FeedbackForm from '~/components/shared/FeedbackForm';

export default {
	name: 'MainSelfServicePageCustom',

	components: {
		BlockList,
		PageHero,
		SvgExternalArrowIcon,
		SvgMitidIcon,
		RelatedPages,
		FeedbackForm,
	},

	inheritAttrs: false,
	props: {
		title: String,
		contentElements: Array,
		header: Object,
		breadcrumb: Array,
		thisIsHowYouDo: Array,
		thisIsWhatYouNeed: Array,
		link: Array,
		linkDescription: String,
		requiredMitId: Boolean,
		showRelatedPages: Object,

		activateFeedback: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			hidden: false,
		};
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onScroll);
	},
	methods: {
		onScroll() {
			const obstacles = document.querySelectorAll(
				'*[class*="c-block-list-"][class*="--wide"]'
			);
			if (obstacles?.length && this.$refs?.content) {
				this.hidden = !Array.from(obstacles).reduce((acc, el) => {
					return (
						this.percentageOverlap(el, this.$refs.content, 96) ===
							0 && acc
					);
				}, true);
			}
		},
		/** Helper Functions: */
		percentageOverlap(first, second, margin = 0) {
			const {
				height: fh,
				width: fw,
				left: fx,
				top: fy,
			} = first.getBoundingClientRect();
			const {
				height: sh,
				width: sw,
				left: sx,
				top: sy,
			} = second.getBoundingClientRect();
			const left = Math.max(fx - margin, sx);
			const right = Math.min(fx + fw + margin, sx + sw);
			const top = Math.max(fy - margin, sy);
			const bottom = Math.min(fy + fh + margin, sy + sh);
			const ip = ((left - right) * (top - bottom)) / (fw * fh);
			return Math.max(Math.min(ip, 1), 0);
		},
	},
};
</script>

<style lang="postcss">
@screen >=1024 {
	.d-self-service-page-custom
		.d-self-service-page-custom__block-list
		> .c-block-list__block:not([class*='--wide']),
	.d-self-service-page-custom__scooting-content {
		transform: translateX(calc(var(--grid-column) + var(--grid-gutter)));
	}
}
</style>
